import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AppShell } from './app/AppShell.js';
import { FilterProvider } from './app/FilterProvider.js';
import { NewContentProvider } from './features/content/NewContentProvider.js';
import { ProposalReviewProvider } from './features/content/ProposalReviewProvider.js';
import { useAuth } from './auth/AuthProvider.js';
import { NovaOrb } from './components/NovaOrb.js';
import { ActivityPage } from './pages/ActivityPage.js';
import { AdminPage } from './pages/AdminPage.js';
import { AssetsPage } from './pages/AssetsPage.js';
import { AgentsPage } from './pages/AgentsPage.js';
import { AreasPage } from './pages/AreasPage.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { EditorialPlanPage } from './pages/EditorialPlanPage.js';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage.js';
import { KpiPage } from './pages/KpiPage.js';
import { LeaderPage } from './pages/LeaderPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { MarkedPage } from './pages/MarkedPage.js';
import { NotificationsPage } from './pages/NotificationsPage.js';
import { ResetPasswordPage } from './pages/ResetPasswordPage.js';
import { SalgPage } from './pages/SalgPage.js';
import { SoMePage } from './pages/SoMePage.js';
import { PrioriteringPage } from './features/sales/PrioriteringPage.js';

export function App() {
  return (
    <Routes>
      <Route path="/logg-inn" element={<LoginPage />} />
      <Route path="/glemt-passord" element={<ForgotPasswordPage />} />
      <Route path="/tilbakestill-passord" element={<ResetPasswordPage />} />
      <Route
        element={
          <RequireAuth>
            <FilterProvider>
              <NewContentProvider>
                <ProposalReviewProvider>
                  <AppShell />
                </ProposalReviewProvider>
              </NewContentProvider>
            </FilterProvider>
          </RequireAuth>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/plan" element={<EditorialPlanPage />} />
        <Route path="/plan/:contentId" element={<EditorialPlanPage />} />
        <Route path="/omrader" element={<AreasPage />} />
        <Route path="/agenter" element={<AgentsPage />} />
        <Route path="/kpi" element={<KpiPage />} />
        <Route path="/some" element={<SoMePage />} />
        <Route path="/varsler" element={<NotificationsPage />} />
        <Route path="/aktivitet" element={<ActivityPage />} />
        <Route path="/utstyr" element={<AssetsPage />} />
        <Route path="/ledelse" element={<LeaderPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/salg" element={<SalgPage />} />
        <Route path="/salg/anbud/:id" element={<SalgPage />} />
        <Route path="/marked" element={<MarkedPage />} />
        <Route path="/marked/:id" element={<MarkedPage />} />
        <Route path="/prioritering" element={<PrioriteringPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <BootScreen />;
  if (status === 'anonymous') {
    return <Navigate to="/logg-inn" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}

function BootScreen() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4">
      <NovaOrb size={16} />
      <p className="label-micro">Kobler til Nova</p>
    </div>
  );
}
